import {
  api,
  apiCall,
  apiActionDispatcher,
  byIdResponseHandler,
  multiIdApiActionDispatcher,
  multiIdApiCall,
  multiIdRequestCacheCheck,
  signalRWrappedApiCall
} from './api';
import {
  subscriptionTypes,
  signalRHubManager
} from './signalRHub/signalRHubManager';
import * as types from './types';
import * as reducers from '../reducers';
import { messaging, utils } from '../helpers';
import { flatten, values } from 'lodash';
import Moment from 'moment';
import { payloadsByDateHandler, payloadsByNameHandler }
  from './signalRHub/hubPayloadsHandler';

const baseJobsDispatcherData = {
  actionTypes: types.jobsActionTypes,
  accumulatorIdProp: 'id',
  responseHandler: byId => utils.propertyReducer(flatten(values(byId)), j => j.id, j => j)
};

const fetchJobsByBuildIdsDispatcher = multiIdApiActionDispatcher({
  ...baseJobsDispatcherData,
  requestName: 'byBuildId'
});
export const fetchJobsByBuildIds = (buildIds) => multiIdApiCall(
  fetchJobsByBuildIdsDispatcher,
  api.jobs.fetchByBuildIds,
  (state, ids) => multiIdRequestCacheCheck(state.jobs.byBuildId, ids),
  buildIds
);

const fetchJobsByJobIdsDispatcher = multiIdApiActionDispatcher({
  ...baseJobsDispatcherData,
  requestName: 'byJobIds'
});
export const fetchJobsByJobIds = (jobIds) => multiIdApiCall(
  fetchJobsByJobIdsDispatcher,
  api.jobs.fetchByJobIds,
  (state, ids) => multiIdRequestCacheCheck(state.jobs.byJobIds, ids),
  jobIds
);

const fetchJobOnDemandDispatcher = apiActionDispatcher({
  actionTypes: types.jobsActionTypes,
  errorMessage: messaging.JOB_NOT_FOUND,
  responseHandler: response => {
    return response ?
      byIdResponseHandler([response]) :
      {};
  }
});


export const fetchJobByNameAndNumber = (jobName, jobNumber) =>
  apiCall(
    fetchJobOnDemandDispatcher,
    api.jobs.fetchJobByNameAndNumber,
    state => {
      const jobsByNameNumber = reducers.getNameNumberJobIdPairs(state);
      return !!jobsByNameNumber[`${jobName}_${jobNumber}`];
    },
    null,
    null,
    [jobName, jobNumber]
  );

const fetchJobsByDateDispatcher = apiActionDispatcher({
  ...baseJobsDispatcherData,
  requestName: 'byJobDate'
});

export const SET_FETCH_DATES = 'SET_FETCH_DATES';
export const fetchJobsByDate = (names, lower, upper) =>
  (dispatch, getState) =>
  {
    // if the previous fetch job request hasn't finished the latest
    // fetch dates need to be extended, not overwritten
    const state = getState();
    const finalUpper = state.jobs.byJobDate.inProgress ?
      reducers.getMetricsByDateUpperLatestFetch(state) :
      upper;

    dispatch({
      type: SET_FETCH_DATES,
      lower,
      upper: finalUpper
    });

    return dispatch(signalRWrappedApiCall(
      apiCall(
        fetchJobsByDateDispatcher,
        api.jobs.fetchByDateRange,
        () => state.metricsByDateInfo.lowerLatestFetch <= lower,
        null,
        null,
        [
          flatten(names),
          Moment(lower, 'X').format('YYYY-MM-DD'),
          Moment(upper, 'X').format('YYYY-MM-DD')
        ]
      ),
      fetchJobsByDateDispatcher,
      signalRHubManager,
      subscriptionTypes.jobsByDateType,
      state => [reducers.getMetricsByDateLowerLatestFetch(state)],
      (args, payloads) => payloadsByDateHandler(args, payloads, 'created_at')
    ));
  };

const fetchJobsByDispatcherTypeDispatcher = apiActionDispatcher({
  ...baseJobsDispatcherData,
  requestName: 'byDispatcherType'
});

export const fetchRecentDispatcherJobsByDispatcherType = (dispatcherType) =>
  signalRWrappedApiCall(
    apiCall(
      fetchJobsByDispatcherTypeDispatcher,
      api.jobs.fetchRecentDispatcherJobsByDispatcherType,
      state => {
        const jobName = reducers.getDispatcherJobName(state);
        if (jobName) {
          const jobs = reducers.getJobsByName(state, jobName);
          return jobs && jobs.length > 0;
        }
        return false;
      },
      null,
      null,
      [dispatcherType]
    ),
    fetchJobsByDispatcherTypeDispatcher([]),
    signalRHubManager,
    subscriptionTypes.jobsByDispatcherType,
    state => [reducers.getDispatcherJobName(state)],
    (args, payloads) => payloadsByNameHandler(args, payloads, 'name')
  );


// WEBPACK FOOTER //
// src/actions/jobs.js